import React, { useEffect, useRef, useState } from 'react'

function addAnimateInStyleBlock(input = '') {
  return input.replace(
    /(<style>)([\s\S]*?)(<\/style>)/gi,
    (_, openTag, styleContent, closeTag) => {
      const updatedStyle = styleContent.replace(
        /(^|\s|{|}|;)(#\w+)/g,
        '$1.svganimate $2'
      )
      return `${openTag}${updatedStyle}${closeTag}`
    }
  )
}

const RemoteSvgWithCSS = ({
  url = '',
  svgContent = '',
  classNames = '',
  ...props
}) => {
  const [content, setContent] = useState(null)
  const svgRef = useRef(null)
  const timeoutRef = useRef(null) // Add this ref

  useEffect(() => {
    if (!svgContent) return
    setContent(addAnimateInStyleBlock(svgContent))
  }, [svgContent])

  useEffect(() => {
    if (!content || !svgRef.current) return

    const node = svgRef.current
    let observer = null

    if (node) {
      observer = new window.IntersectionObserver(
        ([entry]) => {
          const target = entry.target
          if (entry.isIntersecting) {
            target.classList.remove('svganimate')

            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current)
            }

            timeoutRef.current = setTimeout(() => {
              target.classList.add('svganimate')
            }, 100)
          }
        },
        { threshold: 0.2 }
      )

      observer.observe(node)
    }

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [content])

  return content ? (
    <div
      tabIndex={0}
      ref={svgRef}
      data-url={url}
      className={`RemoteSvgWithCSS svganimate ${classNames}`}
      {...props}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  ) : null
}

export default RemoteSvgWithCSS
